import React, { useRef } from 'react'
import { Box, Flex, Image } from 'theme-ui'
import { PopupButton } from '@typeform/embed-react'
import ShuffledImages from './ShuffledImages'

const OutroSection = ({ formId }) => {
  const sectionRef = useRef(null)
  const quoteImage = [
    {
      src: '/images/clubhouse/outro/outro_quote_mobile.svg',
      alt: 'Outro Quote',
    },
    {
      src: '/images/clubhouse/outro/outro_quote.svg',
      alt: 'Outro Quote',
    },
  ]

  return (
    <Flex
      ref={sectionRef}
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        pb: ['2rem', '5rem'],
        position: 'relative',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '90vh',
        maxHeight: ['750px', '850px', '1000px'],
        minHeight: ['750px', '850px', '950px'],
        overflow: 'hidden',
      }}
    >
      <Image
        src="/images/clubhouse/outro/outro-bg.jpg"
        alt="Outro"
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'cover',
          position: 'absolute',
          zIndex: 0,
        }}
      />
      <PopupButton
        id={formId || 'dImjDByp'}
        size={100}
        style={{
          backgroundColor: 'none',
          border: 'none',
          background: 'none',
          padding: 0,
          cursor: 'pointer',
          zIndex: 0,
        }}
      >
        <Image
          src={quoteImage[0].src}
          alt={quoteImage[0].alt}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: ['90%', '70%', '0'],
            maxWidth: ['400px', '500px', '0'],
            height: 'auto',
            zIndex: 6,
            display: ['block', 'block', 'none'],
          }}
        />
        <Image
          src={quoteImage[1].src}
          alt={quoteImage[1].alt}
          sx={{
            position: 'absolute',
            bottom: '0%',
            left: '30%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1,
            display: ['none', 'none', 'block'],
          }}
        />
      </PopupButton>
      <Box sx={{ width: '100%', height: '100%' }}>
        <ShuffledImages sectionRef={sectionRef} />
      </Box>
    </Flex>
  )
}

export default OutroSection
